
export const exclude = [
  "prework-study-guide",
  "horiseon",
  "regex-tutorial",
  "benjstorlie",
  "benjstorlie.github.io",
  "four-musketeers",
];

export const showcase = [
  'sudoku-shuffle',
  'tech-blog',
  'pick-a-pic'
];

/** 
 * Location of a cover image file within the "public" folder.
 * @param {string} repoName - save the image with the same name as the repo.
 */
function coverUrl(repoName) {
  return `/repo-covers/${repoName}.png`
}

/**
 * @typedef RepoDetails - Custom data for projects to override fetched data from Github. Can also include properties based on the github api object, like html_url, or topics.
 * @type {object}
 * @prop {string} [title] - Title to show on card. Default capitalize words and remove dashes.
 * @prop {string} [coverImage] - url to a cover image to show on card. Default is what is in the public folder "repo-covers," or if there is a "cover.png" file in the root directory of the main branch on Github.
 * @prop {string} [description] - text to include on card
 * @prop {string} [homepage] - link to website
 */



/**
 * Override fetched data from Github.  Keys are the name of the repo (`projectDetails["my-repo-name"]`).
 * @type {Object<string,RepoDetails>}
 */
export const projectDetails = {
  "chore-champion": {
    coverImage: coverUrl('chore-champion'),
    ownerName: "byronontheboard"
  },
  "sudoku-shuffle": {
    homepage: "https://sudoku-shuffle-8008b5abf537.herokuapp.com/",
    description: "Sudoku puzzle app, with many note-taking options. Users can make an account to pick up their saved games and keep track of statistics.\n\nThis was the final group project for Coding Bootcamp, which was to develop a user-focused MERN stack application.",
    tools: ["React", "Bootstrap", "GraphQL", "MongoDB", "Express", "Node", "Heroku", "HTML", "CSS", "JavaScript"]
  },
  "pick-a-pic": {
    description: "Tool for Augmentative and Alternative Communication, used to make simple symbol boards for people with speech disabilities. Boards created are saved in the user's browser. It uses a picture search API to pair words with pictures for each button, and the browser's speech capability to read aloud the word when the button is tapped.\n\nThis was a group project for Coding Bootcamp.",
    tools: ["HTML", "CSS", "JavaScript", "Bootstrap", "API"]
  },
  "tech-blog": {
    homepage: "https://tech-blog-072023-2817de97af34.herokuapp.com/"
  }
};

exclude.forEach((repo) => {
  if (projectDetails[repo]) {
    projectDetails[repo].exclude = true;
  } else {
    projectDetails[repo] = { exclude: true }
  }
});

showcase.forEach((repo) => {
  if (projectDetails[repo]) {
    projectDetails[repo].showcase = true;
  } else {
    projectDetails[repo] = { showcase: true }
  }
});


// eslint-disable-next-line
const exampleRepoData = [
  {
    "id": 1296269,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjk2MjY5",
    "name": "Hello-World",
    "full_name": "octocat/Hello-World",
    "owner": {
      "login": "octocat",
      "id": 1,
      "node_id": "MDQ6VXNlcjE=",
      "avatar_url": "https://github.com/images/error/octocat_happy.gif",
      "gravatar_id": "",
      "url": "https://api.github.com/users/octocat",
      "html_url": "https://github.com/octocat",
      "followers_url": "https://api.github.com/users/octocat/followers",
      "following_url": "https://api.github.com/users/octocat/following{/other_user}",
      "gists_url": "https://api.github.com/users/octocat/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/octocat/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/octocat/subscriptions",
      "organizations_url": "https://api.github.com/users/octocat/orgs",
      "repos_url": "https://api.github.com/users/octocat/repos",
      "events_url": "https://api.github.com/users/octocat/events{/privacy}",
      "received_events_url": "https://api.github.com/users/octocat/received_events",
      "type": "User",
      "site_admin": false
    },
    "private": false,
    "html_url": "https://github.com/octocat/Hello-World",
    "description": "This your first repo!",
    "fork": false,
    "url": "https://api.github.com/repos/octocat/Hello-World",
    "archive_url": "https://api.github.com/repos/octocat/Hello-World/{archive_format}{/ref}",
    "assignees_url": "https://api.github.com/repos/octocat/Hello-World/assignees{/user}",
    "blobs_url": "https://api.github.com/repos/octocat/Hello-World/git/blobs{/sha}",
    "branches_url": "https://api.github.com/repos/octocat/Hello-World/branches{/branch}",
    "collaborators_url": "https://api.github.com/repos/octocat/Hello-World/collaborators{/collaborator}",
    "comments_url": "https://api.github.com/repos/octocat/Hello-World/comments{/number}",
    "commits_url": "https://api.github.com/repos/octocat/Hello-World/commits{/sha}",
    "compare_url": "https://api.github.com/repos/octocat/Hello-World/compare/{base}...{head}",
    "contents_url": "https://api.github.com/repos/octocat/Hello-World/contents/{+path}",
    "contributors_url": "https://api.github.com/repos/octocat/Hello-World/contributors",
    "deployments_url": "https://api.github.com/repos/octocat/Hello-World/deployments",
    "downloads_url": "https://api.github.com/repos/octocat/Hello-World/downloads",
    "events_url": "https://api.github.com/repos/octocat/Hello-World/events",
    "forks_url": "https://api.github.com/repos/octocat/Hello-World/forks",
    "git_commits_url": "https://api.github.com/repos/octocat/Hello-World/git/commits{/sha}",
    "git_refs_url": "https://api.github.com/repos/octocat/Hello-World/git/refs{/sha}",
    "git_tags_url": "https://api.github.com/repos/octocat/Hello-World/git/tags{/sha}",
    "git_url": "git:github.com/octocat/Hello-World.git",
    "issue_comment_url": "https://api.github.com/repos/octocat/Hello-World/issues/comments{/number}",
    "issue_events_url": "https://api.github.com/repos/octocat/Hello-World/issues/events{/number}",
    "issues_url": "https://api.github.com/repos/octocat/Hello-World/issues{/number}",
    "keys_url": "https://api.github.com/repos/octocat/Hello-World/keys{/key_id}",
    "labels_url": "https://api.github.com/repos/octocat/Hello-World/labels{/name}",
    "languages_url": "https://api.github.com/repos/octocat/Hello-World/languages",
    "merges_url": "https://api.github.com/repos/octocat/Hello-World/merges",
    "milestones_url": "https://api.github.com/repos/octocat/Hello-World/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/octocat/Hello-World/notifications{?since,all,participating}",
    "pulls_url": "https://api.github.com/repos/octocat/Hello-World/pulls{/number}",
    "releases_url": "https://api.github.com/repos/octocat/Hello-World/releases{/id}",
    "ssh_url": "git@github.com:octocat/Hello-World.git",
    "stargazers_url": "https://api.github.com/repos/octocat/Hello-World/stargazers",
    "statuses_url": "https://api.github.com/repos/octocat/Hello-World/statuses/{sha}",
    "subscribers_url": "https://api.github.com/repos/octocat/Hello-World/subscribers",
    "subscription_url": "https://api.github.com/repos/octocat/Hello-World/subscription",
    "tags_url": "https://api.github.com/repos/octocat/Hello-World/tags",
    "teams_url": "https://api.github.com/repos/octocat/Hello-World/teams",
    "trees_url": "https://api.github.com/repos/octocat/Hello-World/git/trees{/sha}",
    "clone_url": "https://github.com/octocat/Hello-World.git",
    "mirror_url": "git:git.example.com/octocat/Hello-World",
    "hooks_url": "https://api.github.com/repos/octocat/Hello-World/hooks",
    "svn_url": "https://svn.github.com/octocat/Hello-World",
    "homepage": "https://github.com",
    "language": null,
    "forks_count": 9,
    "stargazers_count": 80,
    "watchers_count": 80,
    "size": 108,
    "default_branch": "master",
    "open_issues_count": 0,
    "is_template": false,
    "topics": [
      "octocat",
      "atom",
      "electron",
      "api"
    ],
    "has_issues": true,
    "has_projects": true,
    "has_wiki": true,
    "has_pages": false,
    "has_downloads": true,
    "has_discussions": false,
    "archived": false,
    "disabled": false,
    "visibility": "public",
    "pushed_at": "2011-01-26T19:06:43Z",
    "created_at": "2011-01-26T19:01:12Z",
    "updated_at": "2011-01-26T19:14:43Z",
    "permissions": {
      "admin": false,
      "push": false,
      "pull": true
    },
    "security_and_analysis": {
      "advanced_security": {
        "status": "enabled"
      },
      "secret_scanning": {
        "status": "enabled"
      },
      "secret_scanning_push_protection": {
        "status": "disabled"
      }
    }
  }
]